import http from "./http";

const getDriver = (params, cancelToken) => {
  return http.get("/drivers/driver-paginated", {
    params,
    cancelToken,
  });
};

const getListCar = (params) => {
  return http.get("/vehicles/all-vehicles", {
    params
  });
};

const getDriverDetailsById = (params) => {
  return http.get("/drivers/driver-by-id", {
    params,
  });
};

const createDriver = (data) => {
  return http.post("/drivers", data);
};

const updateDriver = (data) => {
  return http.put("/drivers", data);
};

const removeDriver = (id) => {
  return http.delete("/drivers", { 
    params: { id }
  });
};

export default {
  getDriver,
  getDriverDetailsById,
  getListCar,
  createDriver,
  updateDriver,
  removeDriver
};
